// Helper: Load external JavaScript file
function loadScript(src) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

// Helper: Load external CSS file
function loadCSS(href) {
  return new Promise((resolve, reject) => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.onload = resolve;
    link.onerror = reject;
    document.head.appendChild(link);
  });
}

// Immediately run the script
(async () => {
  try {
    // Load jQuery if not already available
    if (!window.jQuery) {
      await loadScript('https://code.jquery.com/jquery-3.7.0.min.js');
    }

    // Load Magnific Popup
    await loadCSS('https://cdn.jsdelivr.net/npm/magnific-popup@1.1.0/dist/magnific-popup.css');
    await loadScript('https://cdn.jsdelivr.net/npm/magnific-popup@1.1.0/dist/jquery.magnific-popup.min.js');

    // Wrap images using vanilla JS
    const container = document.querySelector('.bm-text-column-with-images');
    if (!container) return;

    const images = container.querySelectorAll('img');
    images.forEach((img) => {
      if (img.parentElement.tagName.toLowerCase() !== 'a') {
        const link = document.createElement('a');
        link.href = img.src;
        link.className = 'bm-image-popup';

        const clonedImg = img.cloneNode(true);
        link.appendChild(clonedImg);
        img.replaceWith(link);
      }
    });

    // Initialize Magnific Popup (no arrows)
    jQuery('.bm-text-column-with-images').magnificPopup({
      delegate: 'a.bm-image-popup',
      type: 'image',
      gallery: {
        enabled: true,
        arrowMarkup: '' // removes arrows
      },
      mainClass: 'mfp-fade',
      removalDelay: 300
    });

  } catch (error) {
    console.error('Magnific Popup error:', error);
  }
})();
